DeviceManager.Internal.PaymentTerminal = {
  getCapabilities: async function () {
    let capabilities = {
      items: [],
      devices: []
    };
    if (DeviceManager.Internal.PaymentTerminal.SalonhubPay) {
      capabilities.items.push(DeviceManager.Internal.PaymentTerminal.SalonhubPay.getCapabilities());
    }
    if (DeviceManager.Internal.PaymentTerminal.Adyen) {
      capabilities.items.push(DeviceManager.Internal.PaymentTerminal.Adyen.getCapabilities());
    }
    return capabilities;
  }
};
//# sourceMappingURL=payment-terminal.js.map
